// extracted by mini-css-extract-plugin
export default {"cardItem":"style_cardItem__Xnln-","statusBadge":"style_statusBadge__k2uOl","disableCards":"style_disableCards__dqhox","statusBadgeNew":"style_statusBadgeNew__Mdnt-"};